<template>
    <footer class="footer">
        <div class="container">
            <div class="footer-logo-section">
                <div class="logos" aria-label="Израду ове базе подржали су Влада Норвешке и Балкански фонд за демократију, пројекат Немачког Маршал фонда Сједињених Америчких Држава.">          
                    <img src="../assets/GMF_LOGO.png" alt="Лого пројекта Немачког Маршал фонда Сједињених Америчких Држава">
                    <img src="../assets/Norway.png" alt="Лого Владе Норвешке">
                    <img src="../assets/svajcarska-vert.jpg" alt="Лого Влада Швајцарске">
                </div>
                <p class="footer-description">Израду ове базе подржали су  Влада Норвешке, Влада Швајцарске и Балкански фонд за демократију, пројекат Немачког Маршал фонда Сједињених Америчких Држава. База је искључива одговорност Удружења новинара Србије (УНС) и не одражава ставове Владе Норвешке, Владе Швајцарске, Немачког Маршал фонда – Балканског фонда за демократију или њихових партнера.</p>
            </div>
            <!-- <p class="footer-heading">Носилац пројекта:</p>
            <ul class="u-m0">
                <li class="footer-logos-item">
                    <a href="http://www.uns.org.rs/" target="_blank" rel="noopener noreferrer">
                    <img class="footer-logos-img" src="../assets/uns-logo.png" alt="UNS">
                </a>
                </li>
            </ul> -->

            <!-- <p class="footer-heading">Партнери на пројекту:</p>-->
            <!-- <ul class="u-m0">
                 <li class="footer-logos-item">
                    <a href="#" rel="noopener noreferrer">
                        <img class="footer-logos-img" src="../assets/logo baza.jpg" alt="Израду ове базе подржали су Влада Норвешке и Балкански фонд за демократију, пројекат Немачког Маршал фонда Сједињених Америчких Држава.">
                    </a>
                </li>
            </ul> -->
                  <!-- 
                <li class="footer-logos-item">
                    <a href="http://www.nuns.rs/" target="_blank" rel="noopener noreferrer">
                        <img class="footer-logos-img" src="../assets/logo-nuns.jpg" alt="NUNS">
                    </a>
                </li>
                <li class="footer-logos-item">
                    <a href="http://www.ndnv.org/" target="_blank" rel="noopener noreferrer">
                        <img class="footer-logos-img" src="../assets/logo-ndnv.jpg" alt="NDNV">
                    </a>
                </li>
                <li class="footer-logos-item">
                    <a href="http://localpress.org.rs/" target="_blank" rel="noopener noreferrer">
                        <img class="footer-logos-img" src="../assets/logo-lp.svg" alt="LP">
                    </a>
                </li>
                <li class="footer-logos-item">
                    <a href="http://www.anem.rs/" target="_blank" rel="noopener noreferrer">
                        <img class="footer-logos-img" src="../assets/logo-anem.jpg" alt="ANEM">
                    </a>
                </li>
            </ul>
            <p>
                Пројекат "Претражи ме - јавна база пројектног суфинансирања медијских пројеката од јавног значаја" суфинансиран је из буџета Републике Србије-Министарства културе и информисања. Ставови изнети у подржаном медијском пројекту нужно не изражавају ставове органа који је доделио средства.
            </p> -->

            <p class="footer-copyright">
                © <a href="http://uns.org.rs/" target="_blank" rel="noopener noreferrer" class="uns-link">Удружење новинара Србије</a>
            </p>
        </div>
    </footer>
</template>